import React, { useState } from "react";
import certificate1 from "../../assets/acrylic-certificate.jpg";
import certificate2 from "../../assets/polyurethane-certificate.jpg";
import certificate3 from "../../assets/running-track-certificate.jpg";
import certificate4 from "../../assets/iso-9001-certificate.jpg";
import certificate5 from "../../assets/iso-14001-certificate.jpg";
import Modal from "../common/CustomModal";

const Certificate = () => {
  const [clickedAward, setClickedAward] = useState<string | null>(null);

  const awards = [
    certificate1,
    certificate2,
    certificate3,
    certificate4,
    certificate5,
  ];

  const scrollingAwards = [...awards, ...awards];

  return (
    <section className="relative w-full px-[5%] bg-[#f2f3f5ab] border-t border-t-gray-200 py-8 sm:py-10">
      <div className="maxContainer overflow-hidden">
        <div className="certificate-track flex gap-4 w-max">
          {scrollingAwards.map((award, index) => (
            <button
              type="button"
              key={`${award}-${index}`}
              onClick={() => setClickedAward(award)}
              className="w-[220px] h-[180px] sm:w-[240px] sm:h-[190px] md:w-[260px] md:h-[200px] p-2 border-2 border-gray-200 rounded-sm bg-white shadow-sm hover:shadow-md shrink-0"
            >
              <div className="w-full h-full p-3 border border-tertiary">
                <img
                  src={award}
                  className="object-contain w-full h-full"
                  alt={`certificate-${(index % awards.length) + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </button>
          ))}
        </div>
      </div>

      <Modal
        isOpen={!!clickedAward}
        onClose={() => setClickedAward(null)}
        size="max-content"
      >
        <img
          src={clickedAward!}
          className="object-contain sm:object-cover max-h-[80vh] w-auto max-w-full"
          alt="certification preview"
        />
      </Modal>
    </section>
  );
};

export default Certificate;
